import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// api
import baseApi from "../../api/baseApi";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
  isLoading: false,
  autoClose: 5000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const initialState = {
  customer: {},
  customerLoading: true,
  customerRefresh: true,

  customers: [],
  customersLoading: true,
  customersRefresh: true,

  customersBySearch: [],
  customersBySearchLoading: false,
  customersBySearchRefresh: true,

  customerStatus: {},
  customerStatusLoading: true,
  customerStatusRefresh: true,

  createCustomerLoading: false,
  updateCustomerLoading: false,
  deleteCustomerLoading: false,
};

export const fetchCustomer = createAsyncThunk(
  "customer/fetchCustomer",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Customers/${id}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCustomers = createAsyncThunk(
  "customer/fetchCustomers",
  async () => {
    try {
      const response = await baseApi.get(`/Customers`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCustomersBySearch = createAsyncThunk(
  "customer/fetchCustomersBySearch",
  async (term) => {
    if (!term) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(`/Customers/Search?term=${term}`);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const fetchCustomerStatus = createAsyncThunk(
  "customer/fetchCustomerStatus",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.get(
        `/Customers/GetCustomerVisitStatus?customerId=${id}`
      );

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createCustomer = createAsyncThunk(
  "customer/createCustomer",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      plateNumber: values.plateNumber,
      email: values.email,
      companyId: values.companyId,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Customers`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const updateCustomer = createAsyncThunk(
  "customer/updateCustomer",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      id: values.id,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      plateNumber: values.plateNumber,
      email: values.email,
      companyId: values.companyId,
      isActive: values.isActive,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.put(`/Customers/${values.id}`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  "customer/deleteCustomer",
  async (id) => {
    if (!id) {
      const errMsg = "Id bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Siliniyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.delete(`/Customers/${id}`);

      toast.update(loadingToast, {
        render: "Silindi.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState: initialState,
  reducers: {
    clearCustomersBySearch: (state) => {
      state.customersBySearch = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomer.pending, (state, action) => {
        state.customerLoading = true;
        state.customer = {};
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.customer = action.payload;
        state.customerLoading = false;
      })
      .addCase(fetchCustomer.rejected, (state, action) => {
        state.customer = {};
        state.customerLoading = false;
      });

    builder
      .addCase(fetchCustomers.pending, (state, action) => {
        state.customersLoading = true;
        state.customers = [];
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.customers = action.payload;
        state.customersLoading = false;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.customers = [];
        state.customersLoading = false;
      });

    builder
      .addCase(fetchCustomersBySearch.pending, (state, action) => {
        state.customersBySearchLoading = true;
        state.customersBySearch = [];
      })
      .addCase(fetchCustomersBySearch.fulfilled, (state, action) => {
        state.customersBySearch = action.payload;
        state.customersBySearchLoading = false;
      })
      .addCase(fetchCustomersBySearch.rejected, (state, action) => {
        state.customersBySearch = [];
        state.customersBySearchLoading = false;
      });

    builder
      .addCase(fetchCustomerStatus.pending, (state, action) => {
        state.customerStatusLoading = true;
        state.customerStatus = {};
      })
      .addCase(fetchCustomerStatus.fulfilled, (state, action) => {
        state.customerStatus = action.payload;
        state.customerStatusLoading = false;
      })
      .addCase(fetchCustomerStatus.rejected, (state, action) => {
        state.customerStatus = {};
        state.customerStatusLoading = false;
      });

    builder
      .addCase(createCustomer.pending, (state, action) => {
        state.createCustomerLoading = true;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.createCustomerLoading = false;
        state.customersRefresh = !state.customersRefresh;
      })
      .addCase(createCustomer.rejected, (state, action) => {
        state.createCustomerLoading = false;
      });

    builder
      .addCase(updateCustomer.pending, (state, action) => {
        state.updateCustomerLoading = true;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.updateCustomerLoading = false;
        state.customersRefresh = !state.customersRefresh;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.updateCustomerLoading = false;
      });

    builder
      .addCase(deleteCustomer.pending, (state, action) => {
        state.deleteCustomerLoading = true;
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.deleteCustomerLoading = false;
        state.customersRefresh = !state.customersRefresh;
      })
      .addCase(deleteCustomer.rejected, (state, action) => {
        state.deleteCustomerLoading = false;
      });
  },
});

export const { clearCustomersBySearch } = customerSlice.actions;

export default customerSlice.reducer;
